import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private ws: PostmethodService) { }

  getCustomerReqMasterList(): Observable<any> {
    const requestPayload = { flag: 'list' };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'customerRequirementMaster'
    );
  }

  createCustomerReqMaster(data: any): Observable<any> {
    const requestPayload = { ...data, flag: 'create' };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'customerRequirementMaster'
    );
  }

  updateCustomerReqMaster(id: number, data: any): Observable<any> {
    const requestPayload = { ...data, flag: 'update', id };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'customerRequirementMaster'
    );
  }

  deleteCustomerReqMaster(id: number): Observable<any> {
    const requestPayload = { id, flag: 'delete' };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'customerRequirementMaster'
    );
  }

  getInterestLevelMaster(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "interesetLevelMaster");
  }
}
